import { reactive } from 'vue'

import type { AuthState } from '../types'

const AUTH_CHECK_URL = 'https://account.wps.cn/p/auth/check'
const LOGIN_URL = 'https://account.wps.cn'
const USER_CENTER_URL = 'https://account.wps.cn/usercenter/apps'

const authState = reactive<AuthState>({
  checked: false,
  loggedIn: false,
  nickname: '',
  avatar: '',
  userid: 0,
  account: '',
})

interface AuthCheckResponse {
  result?: string
  userid?: number
  nickname?: string
  pic?: string
  account?: string
}

async function checkLogin(): Promise<boolean> {
  if (typeof window === 'undefined') {
    authState.checked = true
    return false
  }

  try {
    const res = await fetch(AUTH_CHECK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ cached: true }),
    })

    if (res.status === 403 || !res.ok) {
      authState.loggedIn = false
      authState.checked = true
      return false
    }

    const data = (await res.json()) as AuthCheckResponse
    if (data.result === 'ok' && data.userid) {
      authState.loggedIn = true
      authState.nickname = data.nickname || ''
      authState.avatar = data.pic || ''
      authState.userid = data.userid
      authState.account = data.account || ''
      const { setAccountId } = await import('../util/report')
      setAccountId(String(data.userid))
    } else {
      authState.loggedIn = false
    }
  } catch {
    authState.loggedIn = false
  }
  authState.checked = true
  return authState.loggedIn
}

function redirectToLogin(): void {
  const cb = encodeURIComponent(window.location.href)
  window.location.href = `${LOGIN_URL}?cb=${cb}`
}

function goToUserCenter(): void {
  window.open(USER_CENTER_URL, '_blank')
}

function requireLogin(): boolean {
  if (!authState.loggedIn) {
    redirectToLogin()
    return false
  }
  return true
}

export function useAuth() {
  return {
    authState,
    checkLogin,
    redirectToLogin,
    goToUserCenter,
    requireLogin,
  }
}
